import React from 'react'

import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'

import {HeroSectionMarketing} from './HeroSectionMarketing'
import {HeroSectionNonVio} from './HeroSectionNonVio'

export const HeroSection: React.FC = () => {
  const {
    shell: {homeHeroLayout}
  } = useBrandCapabilities()

  if (homeHeroLayout === 'marketing') return <HeroSectionMarketing />

  return <HeroSectionNonVio />
}
